
<div class="_dialog-title">
  <div class="flex-grow-1 text-xl">{{'pay_by_items_title' | translate}}</div>
  <button mat-icon-button (click)="cancel()" class="dialog-close-button">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<div class="_dialog-content border-top">

  <div class="diners-chart">
    <div class="_inner">
      @for (opt of arrPlaceholders; track opt; let index = $index) {
        @if (index < payload.dinersCount) {
          <div [class.text-accent]="index < payload.selectedCount">
            <mat-icon [svgIcon]="index < payload.selectedCount ? 'user_full' : 'user_outline'"></mat-icon>
          </div>
        }
      }
    </div>
  </div>

  <table class="diners-table">
    <tr>
      <td class="_start"><span>{{'paying_for' | translate}}</span></td>
      <td class="_center">
        <button type="button" class="btn-bordered-image text-base" style="width:150px">
          <div class="image-icon-badge" (click)="addSelectedCount(-1)"><mat-icon svgIcon="minus"></mat-icon></div>
          <div class="_v">
            <mat-icon svgIcon="user_full"></mat-icon>
            <b>{{payload.selectedCount}}</b>
          </div>
          <div class="image-icon-badge" (click)="addSelectedCount(1)"><mat-icon svgIcon="plus"></mat-icon></div>
        </button>
      </td>
      <td class="_end"></td>
    </tr>
    <tr><td></td><td style="height:20px"></td><td></td></tr>
    <tr>
      <td class="_start"><span>{{'out_of' | translate}}</span></td>
      <td class="_center">
        <button type="button" class="btn-bordered-image text-base" style="width:150px">
          <div class="image-icon-badge" (click)="addDinersCount(-1)"><mat-icon svgIcon="minus"></mat-icon></div>
          <div class="_v">
            <mat-icon svgIcon="user_full"></mat-icon>
            <b>{{payload.dinersCount}}</b>
          </div>
          <div class="image-icon-badge" (click)="addDinersCount(1)"><mat-icon svgIcon="plus"></mat-icon></div>
        </button>
      </td>
      <td class="_end"><span>{{'at_the_table' | translate}}</span></td>
    </tr>
  </table>
</div>


<div class="_dialog-actions">

  <div class="_balance-info mb-2">
    <div class="me-3">{{'PO.REMAINED_PAY' | translate}}:</div>
    <div>{{this.data.balanceDue | lcurrency:'1.2-2'}}</div>
  </div>

  <button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (click)="apply()" [disabled]="!payload.amount">
    <div class="_inner">
      <span>{{'PAY' | translate}}</span>
      @if (payload.amount) {
        <span>{{payload.amount | lcurrency}}</span>
      }
      <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
    </div>
  </button>
  @if (payload.amount > this.data.balanceDue) {
    <div class="text-accent text-center font-bold mt-1 animated faster slideInUp">{{'surcharge_will_be_added_to_tip' | translate}}</div>
  }

</div>

